import { createSlice } from "@reduxjs/toolkit";
import { getCourse, getPills } from "../actions";

const initialState = {
  getCourse: {
    data: null,
    isLoading: false,
    error: false,
  },
  getPills: {
    data: null,
    isLoading: false,
    error: false,
  },
};

const courseSlice = createSlice({
  name: "course",
  initialState,
  reducers: {
    resetCourseError: (state) => {
      state.getCourse.error = false;
    },
    resetPillsError: (state) => {
      state.getPills.error = false;
    },
    // The Premium CTA became due as a menu was opened ("Menu visualizzato",
    // client 25/09/2026): show the bar now, without reloading the course.
    courseCtaReceived: (state, action) => {
      const data = state.getCourse.data;
      if (!data || !action.payload) return;
      if (data.course) data.course.cta = action.payload;
      else data.cta = action.payload;
    },
  },
  extraReducers: (builder) => {
    // getCourse
    builder.addCase(getCourse.pending, (state) => {
      state.getCourse.isLoading = true;
      state.getCourse.error = false;
    });
    builder.addCase(getCourse.fulfilled, (state, action) => {
      state.getCourse.isLoading = false;
      state.getCourse.error = false;
      state.getCourse.data = action.payload;
    });
    builder.addCase(getCourse.rejected, (state, action) => {
      state.getCourse.isLoading = false;
      state.getCourse.error = action.error.message;
      // Only clear data if we never had any — preserve stale data on 429/network errors
      // so the UI doesn't flash skeleton when data exists but a refresh failed
      if (!state.getCourse.data) {
        state.getCourse.data = null;
      }
    });

    // getPills
    builder.addCase(getPills.pending, (state) => {
      state.getPills.isLoading = true;
      state.getPills.error = false;
    });
    builder.addCase(getPills.fulfilled, (state, action) => {
      state.getPills.isLoading = false;
      state.getPills.error = false;
      state.getPills.data = action.payload;
    });
    builder.addCase(getPills.rejected, (state, action) => {
      state.getPills.isLoading = false;
      state.getPills.error = action.error.message;
    });
  },
});

export const { resetCourseError, resetPillsError, courseCtaReceived } = courseSlice.actions;
export default courseSlice.reducer;
